import { css } from 'styled-components';

export const createAnimationOnAppear = (
  animationName: string,
  styleWhenHidden: string,
  styleWhenVisible: string,
  animationDuration = 1,
) => css`
  @keyframes ${animationName} {
    0% {
      ${styleWhenHidden}
    }

    100% {
      ${styleWhenVisible}
    }
  }
  animation-name: ${animationName};
  animation-duration: ${animationDuration}s;
  animation-fill-mode: forwards;
  ${styleWhenHidden}
`;
